import { ApiResponse } from '@/domain';
import { backendApi } from '../backendApi'
import { CompleteRedemptionRequest, Redemption, RedemptionFilters } from '@/domain/redeem/redeem'

export const redeemApi = {
  getRedemptions: (filters: RedemptionFilters = {}) =>
    backendApi
      .get<ApiResponse<Redemption[]>>('/api/v1/redemptions', { params: filters })
      .then((res) => res.data.data),

  getRedemption: (id: string) =>
    backendApi
      .get<ApiResponse<Redemption>>(`/api/v1/redemptions/${id}`)
      .then((res) => res.data.data),

  getRedemptionsByContract: (contractId: string) =>
    backendApi
      .get<ApiResponse<Redemption[]>>(`/api/v1/data/redemptions/${contractId}`)
      .then((res) => res.data.data),

  deleteRedemption: (id: string) =>
    backendApi
      .delete<{ code: number; message: string }>(`/api/v1/redemptions/${id}`)
      .then((res) => res.data),

  updateRedemption: (id: string, data: CompleteRedemptionRequest) =>
    backendApi
      .post<ApiResponse<Redemption>>(`/api/v1/orch/redemptions/${id}/agreements`, data)
      .then((res) => res.data.data),
}
